import React, { FC, useState } from 'react'
import Modal from 'react-modal'
import { ConnectedProps, connect } from 'react-redux'

import { Button, FormInputNumber, FormInputText } from 'Components'
import HeaderSmallModal from 'Components/HeaderSmallModal/HeaderSmallModal'
import { JournalEnergyMotionRecord } from 'Models'
import { updateJournalEnergyMotionRecordAction } from 'ReduxStore/journalEnergyMotionRecords'
import { modalZIndexPriority } from 'Utils/zIndexPriority'

const mapDispatchToProps = {
  updateJournalEnergyMotionRecord: updateJournalEnergyMotionRecordAction
}

const connector = connect(null, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  isOpen?: boolean
  onClose: () => void
  journalEnergyMotionRecord?: JournalEnergyMotionRecord
  addJournalEnergyMotionRecord?: (description: string, energy: number, duration: number) => void
  resetOnClose?: boolean
}

const AddEnergyMotionRecord: FC<Props> = ({
  isOpen,
  onClose,
  resetOnClose = false,
  journalEnergyMotionRecord,
  addJournalEnergyMotionRecord,
  updateJournalEnergyMotionRecord
}: Props) => {
  const [energy, setEnergy] = useState<number | undefined>(
    (journalEnergyMotionRecord && journalEnergyMotionRecord.energy) || undefined
  )

  const [duration, setDuration] = useState<number | undefined>(
    (journalEnergyMotionRecord && journalEnergyMotionRecord.duration / 60) || undefined
  )

  const [description, setDescription] = useState(
    () => (journalEnergyMotionRecord && journalEnergyMotionRecord.description) || ''
  )

  const handleClose = (): void => {
    if (resetOnClose) {
      setEnergy(undefined)
      setDuration(undefined)
      setDescription('')
    }
    onClose()
  }

  const onSubmit = (): void => {
    if (energy && energy > 0 && duration && duration > 0 && description && description.length > 0) {
      if (!journalEnergyMotionRecord) {
        addJournalEnergyMotionRecord && addJournalEnergyMotionRecord(description, energy, duration * 60)
      } else {
        updateJournalEnergyMotionRecord({
          id: journalEnergyMotionRecord.id,
          energy,
          description,
          duration: duration * 60
        })
      }
    }
    handleClose()
  }

  const isSubmitDisabled = energy === undefined || duration === undefined || description === ''

  const formFields = (
    <>
      <div className="col-12 col-lg-6">
        <FormInputNumber name="duration" label="Minuten" value={duration} onChange={setDuration} />
      </div>
      <div className="col-12 col-lg-6">
        <FormInputNumber name="energy" label="kcal" value={energy} onChange={setEnergy} />
      </div>
      <div className="col-12">
        <FormInputText name="description" label="Beschreibung" value={description} onChange={setDescription} />
      </div>
    </>
  )

  const SubmitButton: React.FC = () => {
    return (
      <Button id="submitJournalEnergyRecord" onClick={onSubmit} disabled={isSubmitDisabled}>
        {journalEnergyMotionRecord ? 'Speichern' : 'Hinzufügen'}
      </Button>
    )
  }

  const CancelButton: React.FC = () => {
    return (
      <Button type="button" theme="secondary" onClick={handleClose}>
        Abbrechen
      </Button>
    )
  }

  if (isOpen !== undefined) {
    return (
      <Modal style={modalZIndexPriority} isOpen={isOpen} onRequestClose={handleClose} ariaHideApp={false}>
        <div className="modal is-small p-0 bg-white">
          <HeaderSmallModal onClose={handleClose}>
            <h2>Direkten Eintrag bearbeiten</h2>
          </HeaderSmallModal>
          <div className="row px-3 pt-2">{formFields}</div>

          <div className="row px-3 pb-3">
            <div className="col-12 col-sm-6">
              <CancelButton />
            </div>

            <div className="col-12 col-sm-6">
              <SubmitButton />
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  return (
    <div className="row">
      {formFields}
      <div className="col-12">
        <SubmitButton />
      </div>
    </div>
  )
}

export default connector(AddEnergyMotionRecord)
